<template>
  <div class="registration-upload">
    <md-toolbar class="md-primary nav-style first-nav">
      <img src="../assets/logo.png" class="logo_navbar" />
      <div class="md-toolbar-section-end nav-style">
        <md-button class="user-mail" @click="logout_active = true">
          <i class="material-icons person-icon">person</i>
        </md-button>
      </div>
    </md-toolbar>
    <div class="md-title second-navbar">COMUNICAZIONE SICURA</div>
    <form id="app" @submit.prevent="submitUpload" class="card-doc-upload">
      <md-card md-with-hover v-if="uploadFileSpinner">
        <md-card-content>
          <md-progress-spinner md-mode="indeterminate"></md-progress-spinner>
        </md-card-content>
      </md-card>

      <md-card md-with-hover v-if="!uploadFileSpinner">
        <md-card-content>
          <div class="md-title title-style">
            Risposta al Servizio Clienti Humanitas
          </div>
          <div class="md-subhead">Tutti i campi sono obbligatori</div>
          <md-field :class="messageClass" md-clearable>
            <label for="mailSubject">Oggetto della comunicazione</label>
            <md-input
              v-model="mailSubject"
              name="mailSubject"
              type="text"
              id="mailSubject"
              value="mailSubject"
            ></md-input>
            <span class="md-error"
              >Completare il campo per poter proseguire</span
            >
          </md-field>
          <md-field md-clearable>
            <label>Inserisci qui il messaggio da inviare</label>
            <md-textarea v-model="textarea" md-counter="200"></md-textarea>
          </md-field>
          <md-field>
            <md-icon>attach_file</md-icon>
            <label>Carica qui uno o più file*</label>
            <md-input
              name="filesText"
              type="text"
              id="filesText"
              @click="triggerInputFile"
              readonly
            ></md-input>
            <input
              type="file"
              multiple
              value="upload"
              accept="image/*, .pdf"
              @change="storePDF($event)"
              name="filesIE"
              id="filesIE"
              style="display:none;"
            />

            <span>solo immagini e pdf, max 25MB</span>
            <span class="md-error" v-if="isEmpty"
              >Caricare uno o più file per poter proseguire</span
            >
          </md-field>
          <md-list class="md-double-line" v-if="file.length > 0">
            <md-subheader style="text-align: left; padding: 20px 30px;"
              >File caricati</md-subheader
            >

            <md-list-item v-for="(item, index) in file" v-bind:key="item.name">
              <md-icon class="md-primary">attach_file</md-icon>

              <div class="md-list-item-text">
                <span>{{ item.name }}</span>
              </div>

              <md-button
                class="md-icon-button md-list-action"
                @click="cancelFile(index)"
              >
                <md-icon>cancel</md-icon>
              </md-button>
            </md-list-item>
          </md-list>
          <br />
          <md-button
            class="md-raised md-accent"
            :md-ripple="false"
            type="submit"
            @submit="submitUpload()"
            :disabled="
              file == null ||
                file.length == 0 ||
                textarea.trim().length == 0 ||
                mailSubject.trim().length == 0
            "
            value="Submit"
            >Invia</md-button
          >
        </md-card-content>
      </md-card>
    </form>
    <div>
      <md-button
        class="md-raised md-accent"
        :md-ripple="false"
        style="text-align: center;"
        :to="{ name: 'PatientDownload' }"
        >Torna agli appuntamenti</md-button
      >
      <md-dialog-confirm
        :md-active.sync="logout_active"
        md-title="Disconnetti"
        md-content="Cliccando 'Conferma' verrai disconnesso e riportato alla pagina iniziale"
        md-confirm-text="Conferma"
        md-cancel-text="Annulla"
        @md-cancel="logout_active = false"
        @md-confirm="logout()"
      />

      <!--<md-button class="md-primary md-raised" @click="showDialog = true">Show Dialog</md-button>-->
    </div>
  </div>
</template>

<script>
import firebase from "firebase/app";
import parsley from "parsleyjs";

import $ from "jquery";
import axios from "axios";
import "firebase/firestore";

import "firebase/auth";
import { LoginChecker } from "@/utils/login-check";

export default {
  name: "registration-upload",
  data() {
    return {
      filesText: "",
      logout_active: false,
      showDialog: false,
      uploadFileSpinner: true,
      isEmpty: false,
      mailSubject: "",
      textarea: "",
      multiple: null,
      file: [],
      idsFileDrive: [],
      fileName: null,
      user: null,
      showLogoutOptions: false,
      name: null,
      surname: null,
      patientMail: null,
      patientTelNumber: null,
      birthDate: null,
      id_patient: null,
      patients: [],
      isIE: false,
      receiptSubject: "Humanitas - Conferma invio comunicazione",
      receiptBody:
        "Gentile Paziente,<br /><br/>" +
        "la sua comunicazione è stata inviata correttamente.<br /><br />" +
        "Per visualizzare lo storico dei file ricevuti ed inviati ad Humanitas, " +
        'la invitiamo a collegarsi alla piattaforma Comunicazione Sicura, cliccando <a href="https://pma-gestionecomunicazioni.humanitas.it/#/view-files">qui</a>.<br />' +
        'Qualora avesse necessità di risponderci potrà farlo cliccando <a href="https://pma-gestionecomunicazioni.humanitas.it/#/registration-phone">qui</a>; potrà eventualmente ' +
        "anche allegare documenti e fotografie.<br /><br />" +
        "Il servizio garantisce la massima sicurezza e riservatezza nel trattamento dei suoi dati, secondo " +
        "la vigente normativa in materia di protezione dei dati personali.<br /><br />" +
        "La ringraziamo per l’attenzione.<br />" +
        "Cordiali saluti,<br />" +
        "IRCCS Istituto Clinico Humanitas"
    };
  },
  computed: {
    messageClass() {
      if (!this.$store.state.detailPhone) {
        //console.log("mancano i dati");
      } else {
        return true;
      }
    }
  },
  mounted: function() {
    //console.log(this.$route.query.ref)
    // controllo esistenza stringa in firestorage
    // controllo auth

    var self = this;
    if (
      !self.$store.state.detailPhone ||
      self.$store.state.detailPhone.length == 0 ||
      !self.$store.state.replyPatientName ||
      self.$store.state.replyPatientName.length == 0 ||
      !self.$store.state.replyPatientSurname ||
      self.$store.state.replyPatientSurname.length == 0 ||
      !self.$store.state.replyPatientMail ||
      self.$store.state.replyPatientMail.length == 0 ||
      !self.$store.state.replyPatientTelNumber ||
      self.$store.state.replyPatientTelNumber.length == 0 ||
      !self.$store.state.replyPatientId ||
      self.$store.state.replyPatientId.length == 0
    ) {
      self.$router.push({ path: "/view-files" });
    } else {
      self.name = self.$store.state.replyPatientName;
      self.surname = self.$store.state.replyPatientSurname;
      self.patientMail = self.$store.state.replyPatientMail;
      self.patientTelNumber = self.$store.state.replyPatientTelNumber;
      self.id_patient = self.$store.state.replyPatientId;
    }
    var ua = window.navigator.userAgent;
    self.isIE = /MSIE|Trident/.test(ua);

    var db = firebase.firestore();
    //console.log(self.$store.state.detailPhone);

    var user = firebase.auth().currentUser;
    //console.log(user);
    if (user) {
      // da mettere ciclo per controllare se + providerData
      if (user.providerData[0].providerId == "phone") {
        //console.log("Phone-Authenticated user");
        self.uploadFileSpinner = false;
        //check utente codice
        //get file URL
      } else {
        self.$store.commit("setRedirectPath", self.$route.fullPath);
        //console.log("User not Phone-Authenticated");
        self.$router.push("/view-files");
      }
    } else {
      //console.log("User not Authenticated");
      self.$store.commit("setRedirectPath", self.$route.fullPath);
      self.$router.push("/view-files");
    }
    // console.log(this.$store.state.detailName, this.$store.state.detailSurname, this.$store.state.detailPrimaryMail, this.$store.state.detailSecondaryMail, this.$store.state.detailPhone)

    //}
    //});
  },
  methods: {
    cancelFile: function(index) {
      var self = this;
      self.file.splice(index, 1);
    },
    triggerInputFile: function() {
      document.getElementById("filesIE").click();
    },
    logout: function() {
      var self = this;
      firebase
        .auth()
        .signOut()
        .then(function() {
          self.$router.push({
            path: "/registration-phone"
          });
        });
    },
    validateEmailAddress: function(email) {
      var re = /^[\w]+([\.\w\-\+\_])*@[\w]+([\.\w\-\+\_])*\.+[a-zA-Z]{2,}$/;
      return re.test(String(email).toLowerCase());
    },
    validatePhoneNumber: function(phoneNumber) {
      var re = /^\+[0-9]*$/;
      return re.test(String(phoneNumber));
    },
    validateBirthDate: function(birthDate) {
      var re = /^((\d{2})\/(\d{2})\/(\d{4}))$/;
      return re.test(String(birthDate));
    },
    storePDF: function(e) {
      var self = this;
      //console.log(e.target.files);
      for (var j = 0; j < e.target.files.length; j++) {
        //console.log(e.target.files[j]);
        self.file.push(e.target.files[j]);
      }
      /*var self = this;
      self.file = e.target.files;
      if (self.isIE){
        //this.filesText = 'test'
        var names = [];
        for (var i=0; i<self.file.length; i++){
          names.push(self.file[i].name);
        }
        self.filesText = names.join(', ');
        //this.filesText = this.file.map(function(elem){
        //  return elem.name;
        //}).join(", ");
      }*/
    },
    upload2Storage: function(fbBucketName, file) {
      //console.log(file);
      var self = this;
      // create a storage ref
      var storageRef = firebase
        .storage()
        .ref(
          `${fbBucketName}/${self.patientTelNumber}/${self.id_patient}/${
            file.name
          }`
        );
      // upload file
      var uploadTask = storageRef.put(file);
      // update progress bar
      uploadTask.on(
        firebase.storage.TaskEvent.STATE_CHANGED, // or 'state_changed'
        function(snapshot) {
          // Get task progress, including the number of bytes uploaded and the total number of bytes to be uploaded
          var progress =
            (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
          //console.log("Upload is " + progress + "% done");
          switch (snapshot.state) {
            case firebase.storage.TaskState.PAUSED: // or 'paused'
              //console.log("Upload is paused");
              break;
            case firebase.storage.TaskState.RUNNING: // or 'running'
              //console.log("Upload is running");
              break;
          }
        },
        function(error) {
          // A full list of error codes is available at
          // https://firebase.google.com/docs/storage/web/handle-errors
          switch (error.code) {
            case "storage/unauthorized":
              // User doesn't have permission to access the object
              break;
            case "storage/canceled":
              // User canceled the upload
              break;
            case "storage/unknown":
              // Unknown error occurred, inspect error.serverResponse
              break;
          }
        },
        function() {
          uploadTask.snapshot.ref.getDownloadURL().then(function(downloadURL) {
            //console.log('url');
            self.downloadURL = downloadURL;
            var updateToHumanitasCollection = self.updateToHumanitasCollectionHumanitas(
              downloadURL,
              file.name
            );
            axios
              .post(
                "/logging",
                {
                  component: "PAZIENTE",
                  event: "Caricamento allegato",
                  patientName: self.name,
                  patientSurname: self.surname,
                  patientEmail: self.patientMail,
                  patientNumber: self.patientTelNumber,
                  description: file.name + " - " + downloadURL
                },
                {
                  headers: {
                    //Authorization: 'Bearer ' + idToken
                  }
                }
              )
              .then(function(data) {
                //console.log("SUCCESS!!");
              })
              .catch(function() {
                //console.log("FAILURE!!");
              });
          });
        }
      );
    },
    upload2TD: function(i) {
      var self = this;
      let formData = new FormData();
      self.fileName = self.file[i].name;
      //console.log(self.fileName)
      formData.append("file", self.file[i]);
      formData.append("patientMail", self.patientMail);

      axios
        .post("/upload2TD", formData, {
          headers: {
            "Content-Type": "multipart/form-data",
            "Access-Control-Allow-Origin": "*",
            "Access-Control-Allow-Headers":
              "Origin, X-Requested-With, Content-Type, Accept",
            "Access-Control-Allow-Methods": "POST"
          }
        })
        .then(function(data) {
          //console.log("SUCCESS!!");
          ////console.log(data.data.data['connections'])
          self.idsFileDrive.push(data.data.data["connections"]);
          //console.log(self.idsFileDrive);

          var updateToHumanitasCollection = self.updateToHumanitasCollectionHumanitas(
            data.data.data["connections"]
          );
          i = i + 1;
          if (i < self.file.length) {
            self.upload2TD(i);
            //console.log('è pi', i+1)
          } else if (i == self.file.length) {
            self.sendMail2Doc();
          }
        })
        .catch(function() {
          self.uploadFileSpinner = false;
          //console.log("FAILURE!!");
        });
    },
    updateToHumanitasCollectionHumanitas: function(filesUrl, nomeFile) {
      var self = this;
      //console.log('update history');
      axios
        .post(
          "/updateHistory",
          {
            fileName: nomeFile,
            patientMail: self.patientMail,
            patientName: self.name,
            patientSurname: self.surname,
            downloadUrl: filesUrl,
            collectionName: "toHumanitas",
            template: "",
            activityState: "Nuovo",
            from: "patient",
            communicationSubj: self.mailSubject,
            communicationMess: self.textarea
          },
          {
            headers: {
              //Authorization: 'Bearer ' + idToken
            }
          }
        )
        .then(function() {
          //console.log("toHumanitas history updated");
        })
        .catch(function() {
          //console.log("toHumaitas history update failed");
        });
    },
    sendMail2Doc: function() {
      //DEMO
      //DEV
      //admin@demo.goreply.io
      //PROD
      //noreply.pma@humanitas.it
      var self = this;
      axios
        .post(
          "/mailToDoc",
          {
            emailSubject: self.mailSubject,
            emailBody: self.textarea,
            url: self.idsFileDrive,
            staffMail: "noreply.pma@humanitas.it",
            userMail: self.patientMail
          },
          {
            headers: {
              //Authorization: 'Bearer ' + idToken
            }
          }
        )
        .then(function(response) {
          //console.log("Email sent");
          self.uploadFileSpinner = false;
          var filenames = [];
          var allegati = "";
          if (self.file) {
            for (var i = 0; i < self.file.length; i++) {
              filenames.push(self.file[i].name);
            }
            allegati = "\nAllegati: " + filenames.join(", ");
          }

          axios
            .post(
              "/logging",
              {
                component: "PAZIENTE",
                event: "Invio Comunicazione",
                patientName: self.name,
                patientSurname: self.surname,
                patientEmail: self.patientMail,
                patientNumber: self.patientTelNumber,
                description: self.textarea + allegati
              },
              {
                headers: {
                  //Authorization: 'Bearer ' + idToken
                }
              }
            )
            .then(function(data) {
              //console.log("SUCCESS!!");
            })
            .catch(function() {
              //console.log("FAILURE!!");
            });
          axios
            .post(
              "/sendmail",
              {
                emailSubject: self.receiptSubject,
                emailBody: self.receiptBody,
                userMail: self.patientMail,
                userNameSurname: self.name + " " + self.surname
              },
              {
                headers: {
                  //Authorization: 'Bearer ' + idToken
                }
              }
            )
            .then(function(response) {})
            .catch(function(error) {});
          self.$router.push({ path: "/act-options" });

          return true;
        })
        .catch(function(error) {
          self.uploadFileSpinner = false;
          //console.log("Error sending mail " + error);
          //console.error('/getContacts ERROR: ' + error)
          self.$notify({
            group: "foo",
            title:
              "Ci spiace, si è verificato un errore durante l'invio della mail, prego riprovare",
            text: "",
            duration: 600,
            max: 1
          });
        });
    },
    submitUpload: function() {
      var self = this;
      if (!self.file) {
        self.uploadFileSpinner = false;
        return {
          "md-invalid": self.isEmpty
        };
      } else {
        if (
          self.mailSubject.trim().length == 0 ||
          self.textarea.trim().length == 0
        ) {
          self.$notify({
            group: "foo",
            title: "Tutti i campi sono obbligatori",
            text: "Oggetto e messaggio della mail non possono essere vuoti.",
            duration: 600
          });
          return;
        }
        var total_size = 0;
        for (var i = 0; i < self.file.length; i++) {
          var item = self.file[i];
          total_size += item.size;
        }
        //console.log(total_size);
        //console.log(total_size/1000000);
        if (total_size / 1000000 > 25) {
          self.$notify({
            group: "foo",
            title: "File superano dimensione massima",
            text: "L'insieme dei file non può superare 25MB.",
            duration: 600
          });
          return;
        }
        if (self.file.length == 0) {
          self.$notify({
            group: "foo",
            title: "Nessun file caricato",
            text: "E' necessario allegare almeno un file!",
            duration: 600
          });
          return;
        }
        self.$store.commit("patientsToClinic");

        self.uploadFileSpinner = true;
        var fbBucketName = "receivedFiles";
        for (var i = 0; i < self.file.length; i++) {
          var file = self.file[i];
          self.fileName = file.name;
          var upStorage = self.upload2Storage(fbBucketName, file);
        }
        var sedMailToPatient = self.sendMail2Doc();
      }
    }
  }
};
</script>

<style scoped>
/* "scoped" attribute limit the CSS to this component only */
.logo_navbar {
  text-align: center;
  height: 40px;
  padding: 3px;
}

.logo_navbar {
  text-align: center;
  height: 40px;
  padding: 3px;
}

.md-card {
  width: 60%;
  margin: 4px;
  display: inline-block;
  vertical-align: center;
}

@media only screen and (max-width: 600px) {
  .md-card {
    width: 80%;
  }
}

.logo {
  margin-top: 60px;
  width: 10%;
  height: 10%;
}

.title-style {
  color: #027953;
  font-size: 20px;
}

.text-style {
  color: #027953;
  font-size: 15px;
  text-align: center;
  padding-top: 1%;
}

.logo_navbar {
  text-align: center;
  height: 40px;
  padding: 3px;
}

.person-icon {
  color: #027953;
}

.logout {
  margin-top: 40px;
}

.home-button {
  width: 487px;
}

.nav-style {
  height: 50px;
}

.second-navbar {
  background-color: #027953;
  font-size: 26px;
  font-weight: bold;
  color: #ffffff;
  padding: 1.3%;
}

.text-card {
  text-align: right;
  color: grey;
}

.simple-text {
  color: black;
  font-size: 17px;
}

.button-text {
  padding-top: 6%;
  padding-left: 1%;
  float: right;
}

.first-nav {
  background-color: #ffffff !important;
}

.user-mail {
  background-color: #f2f1f2;
  text-transform: lowercase;
  border-radius: 22px;
}

.cap {
  text-transform: capitalize;
}
</style>



// WEBPACK FOOTER //
// src/components/RegistrationUploadFile.vue